<div
	class="stages-main-content"
	#mainContent
	[ngClass]="{ expand: applicationState.navigationDrawerOpen === State.FORCE_CLOSED }"
>
	@if (isDisclaimerEnabled) {
		<stages-disclaimer [disclaimerVersion]="disclaimerVersion" />
	}

	@if (!isDisclaimerEnabled) {
		<header id="mobile-header" [ngClass]="{ 'has-banner': bannerEnabled }">
			<button
				type="button"
				[attr.title]="'navigation.workspace.select' | translate"
				[attr.aria-label]="'navigation.workspace.select' | translate"
				class="action"
				(click)="
					applicationState.navigationDrawerOpen =
						applicationState.navigationDrawerOpen === State.FORCE_OPENED ? State.RESPONSIVE : State.FORCE_OPENED
				"
			>
				<div
					class="delightful-icon"
					[ngClass]="{
						hamburger:
							applicationState.navigationDrawerOpen === State.FORCE_CLOSED ||
							applicationState.navigationDrawerOpen === State.RESPONSIVE,
						close: applicationState.navigationDrawerOpen === State.FORCE_OPENED,
					}"
				>
					<span class="first"></span> <span class="second"></span> <span class="third"></span>
				</div>
			</button>
			@if (
				applicationState.navigationDrawerOpen === State.FORCE_CLOSED ||
				applicationState.navigationDrawerOpen === State.RESPONSIVE
			) {
				<button
					type="button"
					[attr.aria-label]="'search' | translate"
					[attr.title]="'search' | translate"
					class="action search-action"
					(click)="toggleSearch()"
				>
					<i class="ico" [ngClass]="{ 'ico-search': !searchOpen, 'ico-close': searchOpen }"></i>
				</button>
			}
			@if (sudoEnabled) {
				<button type="button" class="action" (click)="onChangeSudoMode()">
					<i class="ico ico-superuser-key"></i>
				</button>
			}
			@if (
				applicationState.navigationDrawerOpen === State.FORCE_CLOSED ||
				applicationState.navigationDrawerOpen === State.RESPONSIVE
			) {
				<stages-menu
					menuId="mainMenu"
					[iconClasses]="['ico', 'ico-more-vertical']"
					openTo="left"
					[items]="menuItems"
					[noCollapse]="true"
					class="action"
				></stages-menu>
			}
		</header>
		@if (bannerEnabled) {
			<div id="banner">
				<span class="secondary" [innerHtml]="'global.main.bannerLeftRightText' | translate | safe: 'html'"></span
				><span class="primary" [innerHtml]="'global.main.bannerCenterText' | translate | safe: 'html'"></span
				><span class="secondary" [innerHtml]="'global.main.bannerLeftRightText' | translate | safe: 'html'"></span>
			</div>
		}
		<stages-navigation-drawer #navigationDrawer></stages-navigation-drawer>
		<router-outlet name="clipboard"></router-outlet>
		<div
			id="search"
			[ngClass]="{
				'has-banner': bannerEnabled,
				visible: searchOpen,
				expand: applicationState.navigationDrawerOpen === State.FORCE_CLOSED,
			}"
		>
			<stages-global-search-box></stages-global-search-box>
		</div>
		@if (sudoEnabled && !(layoutService.breakpoint | async)?.isMobile) {
			<div id="sudoflag" [ngClass]="{ 'has-banner': bannerEnabled }" (click)="onChangeSudoMode()">
				<div class="ico ico-superuser-key"></div>
			</div>
		}
		@if (chatbotEnabled && !sudoEnabled && !(layoutService.breakpoint | async)?.isMobile) {
			<button
				type="button"
				[title]="'chatbot.name' | translate"
				[attr.aria-label]="'chatbot.name' | translate"
				[ngClass]="{ 'has-banner': bannerEnabled }"
				id="chatbot-action"
				(click)="mainService.applicationState.toggleChatbot()"
			>
				<i class="ico ico-chatbot-side"></i>
			</button>
		}
		<div
			id="content"
			[ngClass]="{
				'has-banner': bannerEnabled,
				'has-search': searchOpen,
				'has-toolbar': applicationState.toolbarVisible,
				'document-view': applicationState.documentViewEnabled,
			}"
		>
			<div class="scroll-content">
				<div class="wrapper">
					<router-outlet
						name="dialog"
						(activate)="onDialogActivate()"
						(deactivate)="onDialogDeactivate()"
					></router-outlet>
					<!-- *ngIf="!dialogActive" would be better but loses main navigation on reload -->
					<div [hidden]="dialogActive">
						<router-outlet></router-outlet>
					</div>
					<footer class="page-footer">
						<span class="img stages"></span>
					</footer>
				</div>
			</div>
			@if (applicationState.toolbarVisible) {
				<stages-right-navigation-rail [menuItems]="menuItems" [buttons]="menuButtons"></stages-right-navigation-rail>
			}
		</div>
		<!--
      The ui-mask must be always present, it propagates all events to the document on mobile safari
      TC: Open long page on iPad, scroll down, open menu and click on "document", the menu will not be
      closed if the ui-mask is not present because the event does not bubble to the document
      We cannot switch to flexbox because it's impossible to position the stages logo in IE11 (justify-content
      works only with a height set and not with min-height)
      -->
		<div
			id="ui-mask"
			(click)="
				applicationState.navigationDrawerOpen =
					applicationState.navigationDrawerOpen === State.FORCE_OPENED ? State.RESPONSIVE : State.FORCE_OPENED
			"
			[ngClass]="{ visible: applicationState.maskVisible }"
		></div>
		<stages-snackbar></stages-snackbar>
	}
	<router-outlet name="popup" (activate)="onPopupOpened($event)" (deactivate)="onPopupClosed($event)"></router-outlet>
</div>
<stages-sidesheet
	[isSidesheetOpen]="chatbotEnabled && !!(applicationState.isChatbotOpen | async)"
	[bannerEnabled]="bannerEnabled"
>
	@if (chatbotEnabled) {
		<stages-chatbot (closeButtonPressed)="closeSidesheet()" />
	}
</stages-sidesheet>
